import template from './jobsList.template.html';

export default {
  template,
  bindings: {
    jobs: '=',
    accounts: '<',
    tickets: '<',
    workflows: '<',
    contacts: '<',
    labels: '<',
    showAssignedTo: '<',
    showTicket: '<',
    onToggle: '&',
    onEdit: '&',
    onDelete: '&',
    onLabelsSelect: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, listServiceNew) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.jobs = ctrl.jobs || [];
        ctrl.accounts = ctrl.accounts || [];
        ctrl.tickets = ctrl.tickets || [];
        ctrl.workflows = ctrl.workflows || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.labels = ctrl.labels || [];
        ctrl.showAssignedTo = ctrl.showAssignedTo || false;
        ctrl.showTicket = ctrl.showTicket || false;
        ctrl.showsInAll = ctrl.showsInAll !== undefined;
        ctrl.list.setData(ctrl.jobs);
        if (ctrl.jobs.length) {
          ctrl.list.setOrderBy('getDateSort()');
        }
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      ctrl.jobToggle = (data) => {
        ctrl.onToggle({ data });
      };

      ctrl.jobEdit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.jobDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.jobLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.areAllItemsSelected = () => {
        if (ctrl.jobs.length) {
          return _.every(ctrl.jobs, (j) => j.isSelected);
        }
        return false;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (changes.jobs && changes.jobs.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
